export default {
  row: {
    marginTop: '20px',
    '&:first-child': {
      marginTop: '0'
    }
  }
}
